import Vue from 'vue'
import App from './App.vue'
import Amplify from 'aws-amplify'
import vuetify from './plugins/vuetify'
import store from './store/index'
import Vuex from 'vuex'
import CountryFlag from 'vue-country-flag'
import router from './router'
import account from './store/account'
import userConfig from './store/userConfig'
import axios from 'axios'
import { apolloClient } from './vue-apollo'
import VueObserveVisibility from 'vue-observe-visibility'
import VueNativeSock from 'vue-native-websocket'
import VueApollo from 'vue-apollo'
import socket from './store/socket'
import terminalStore from './store/terminalStore'
import globalRaceNetwork from './store/globalRaceNetwork'
import audit from './store/audit'

Amplify.configure({
  Auth: {
    // REQUIRED only for Federated Authentication - Amazon Cognito Identity Pool ID
    // identityPoolId: 'ap-southeast-2_soiOPC3Rc',

    // REQUIRED - Amazon Cognito Region
    region: 'ap-southeast-2',

    // OPTIONAL - Amazon Cognito Federated Identity Pool Region
    // Required only if it's different from Amazon Cognito Region
    // identityPoolRegion: 'XX-XXXX-X',

    // OPTIONAL - Amazon Cognito User Pool ID
    userPoolId: process.env.VUE_APP_COGNITO_POOL_ID,

    // OPTIONAL - Amazon Cognito Web Client ID (26-char alphanumeric string)
    userPoolWebClientId: process.env.VUE_APP_COGNITO_CLIENT_ID,

    // OPTIONAL - Enforce user authentication prior to accessing AWS resources or not
    mandatorySignIn: false,

    // OPTIONAL - Configuration for cookie storage
    // Note: if the secure flag is set to true, then the cookie transmission requires a secure protocol
    // cookieStorage: {
    //     // REQUIRED - Cookie domain (only required if cookieStorage is provided)
    //     domain: '.yourdomain.com',
    //     // OPTIONAL - Cookie path
    //     path: '/',
    //     // OPTIONAL - Cookie expiration in days
    //     expires: 365,
    //     // OPTIONAL - Cookie secure flag
    //     // Either true or false, indicating if the cookie transmission requires a secure protocol (https).
    //     // secure: true
    // },

    // OPTIONAL - customized storage object
    // storage: new MyStorage(),

    // OPTIONAL - Manually set the authentication flow type. Default is 'USER_SRP_AUTH'
    // authenticationFlowType: 'USER_PASSWORD_AUTH',

    // OPTIONAL - Manually set key value pairs that can be passed to Cognito Lambda Triggers
    // clientMetadata: { myCustomKey: 'myCustomValue' },

    // OPTIONAL - Hosted UI configuration
    oauth: {
      domain: process.env.VUE_APP_COGNITO_DOMAIN,
      scope: ['graphql/api'],
      redirectSignIn: process.env.VUE_APP_BASE_URL || 'http://localhost:8081/',
      redirectSignOut: process.env.VUE_APP_BASE_URL || 'http://localhost:8081/',
      responseType: 'code' // or 'token', note that REFRESH token will only be generated when the responseType is code
    }
  }
})

Vue.use(Vuex)
Vue.use(VueObserveVisibility)
Vue.use(VueApollo)
Vue.component('country-flag', CountryFlag)
Vue.config.productionTip = false
store.modules = { ...store.modules, account, userConfig, socket, terminalStore ,globalRaceNetwork,audit }
const s = new Vuex.Store(store)

Vue.use(VueNativeSock, process.env.VUE_APP_ENDPOINT_SOCKET, {
  store: s,
  format: 'json',
  reconnection: true,
  reconnectionAttempts: 5,
  reconnectionDelay: 3000,
  connectManually: true
})

axios.defaults.baseURL = process.env.VUE_APP_ENDPOINT_API

// Add a request interceptor to put auth header
axios.interceptors.request.use(async config => {
  // get token from local storage, if expired, updateAuthToken will refresh the token
  await s.dispatch('account/updateAuthToken')
  const token = window.localStorage.getItem('auth_token')

  config.headers.Authorization = token

  return config
}, err => Promise.reject(err))

const apolloProvider = new VueApollo({
  defaultClient: apolloClient
})

const tbmCPApp = new Vue({
  store: s,
  router,
  vuetify,
  apolloProvider,
  render: h => h(App)
}).$mount('#app')
window.tbmCPApp = tbmCPApp